import { defineComponent, ref, computed, toRef } from 'vue-demi';
import '@vueuse/core';
import { u as usePopoverState } from './usePopoverState-b92c698b.js';
import '@onereach/styles/tailwind.config';
import 'tailwindcss/resolveConfig';
import { s as script$1, P as PopoverPlacement } from './OrPopover-56ba40ab.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, renderSlot, createBlock, withCtx, createElementVNode, toDisplayString, createCommentVNode } from 'vue';

const TooltipRoot = [
// Layout
'layout-inline-row'];
const TooltipBody = [
// Layout
'layout-inline-row',
// Shape
'rounded-sm',
// Spacing
'mx-sm', 'my-sm', 'px-sm', 'py-xs',
// Typography
'typography-caption-regular',
// Theme
'bg-inverse-surface', 'dark:bg-inverse-surface-dark', 'text-inverse-on-surface', 'dark:text-inverse-on-surface-dark'];
const TooltipBodyPlacements = {
  'top': [],
  'top-start': [
  // Spacing
  'ml-none'],
  'top-end': [
  // Spacing
  'mr-none'],
  'bottom': [],
  'bottom-start': [
  // Spacing
  'ml-none'],
  'bottom-end': [
  // Spacing
  'mr-none'],
  'left': [],
  'left-start': [
  // Spacing
  'mt-none'],
  'left-end': [
  // Spacing
  'mb-none'],
  'right': [],
  'right-start': [
  // Spacing
  'mt-none'],
  'right-end': [
  // Spacing
  'mb-none']
};

var script = defineComponent({
  name: 'OrTooltip',
  components: {
    OrPopover: script$1
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: undefined
    },
    placement: {
      type: String,
      default: PopoverPlacement.Bottom
    },
    offset: {
      type: [Number, Object, Function],
      default: undefined
    }
  },
  emits: ['update:state', 'open', 'close'],
  expose: ['root', 'state', 'open', 'close', 'toggle'],
  setup(props, context) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-tooltip-v3', ...TooltipRoot]);
    const bodyStyles = computed(() => [...TooltipBody, ...TooltipBodyPlacements[props.placement]]);
    // State
    const {
      state,
      open,
      close,
      toggle
    } = usePopoverState(toRef(props, 'isOpen'), context.emit, {
      debounce: 250
    });
    return {
      root,
      rootStyles,
      bodyStyles,
      state,
      open,
      close,
      toggle
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrPopover = resolveComponent("OrPopover");
  return openBlock(), createElementBlock("div", {
    ref: "root",
    class: normalizeClass(_ctx.rootStyles),
    onMouseenter: _cache[1] || (_cache[1] = $event => _ctx.open()),
    onMouseleave: _cache[2] || (_cache[2] = $event => _ctx.close())
  }, [renderSlot(_ctx.$slots, "default"), _ctx.text ? (openBlock(), createBlock(_component_OrPopover, {
    key: 0,
    "is-open": _ctx.state === 'open',
    variant: 'popover',
    trigger: _ctx.root,
    placement: _ctx.placement,
    offset: _ctx.offset,
    "disable-default-styles": true,
    "onUpdate:state": _cache[0] || (_cache[0] = $event => _ctx.state = $event)
  }, {
    default: withCtx(() => [createElementVNode("div", {
      class: normalizeClass(_ctx.bodyStyles)
    }, toDisplayString(_ctx.text), 3 /* TEXT, CLASS */)]),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-open", "trigger", "placement", "offset"])) : createCommentVNode("v-if", true)], 34 /* CLASS, HYDRATE_EVENTS */);
}

script.render = render;
script.__file = "src/components/or-tooltip-v3/OrTooltip.vue";

export { script as s };
